import { defineComponent as _defineComponent } from 'vue'
import {
  AccountStates,
  EAccountStatusAction
} from '@/modules/common/services/http/account';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, ButtonPrimary, Heading } from '@warrenbrasil/nebraska-web';
import QrcodeVue from 'qrcode.vue';
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeAccountStatus',
  props: {
  accountStatusResponse: {
    type: Object as () => AccountStates,
    required: true
  }
},
  setup(__props) {

const props = __props


const storeHref = ref('');
const button = props.accountStatusResponse.accountStatus.button;

const showQrCode = computed(() => {
  return button && button.action !== EAccountStatusAction.RegisterOpenLink;
});

const showButtonAction = computed(() => {
  return button && button.action === EAccountStatusAction.RegisterOpenLink;
});

function mountStoreHref() {
  const currentUrl = window.location.href;
  const baseUrl = currentUrl.split('/#/')[0];
  storeHref.value = `${baseUrl}/#/mobile`;
}

onMounted(() => {
  mountStoreHref();
});

return { __sfc: true,props, storeHref, button, showQrCode, showButtonAction, mountStoreHref, NebraskaColors, BaseText, ButtonPrimary, Heading, QrcodeVue }
}

})